import BaseTicketSaleReport from 'Services/SalesManagement/Features/Report/Components/BaseTicketSaleReport'
import {
  BULK_TICKET_SALE_REPORT_PATH,
  BULK_TICKET_SALE_REPORT_PREFIX,
  createBulkTicketSaleReport,
  fetchBulkTicketSaleReport,
  resetBulkTicketSaleReportWebsocket
} from 'Services/SalesManagement/Features/Report/reportSlice'
import useTypedSelector, { useAppDispatch } from 'Store'

export default function BulkTicketSaleReport() {
  const dispatch = useAppDispatch()

  const {
    bulkTicketSaleReportLoading,
    singleBulkTicketSaleReport,
    bulkTicketSaleReportGenerationStatus,
    bulkTicketSaleReportGenerationTask
  } = useTypedSelector(state => state.report)

  return (
    <BaseTicketSaleReport
      reportLoading={bulkTicketSaleReportLoading}
      singleReport={singleBulkTicketSaleReport}
      reportGenerationStatus={bulkTicketSaleReportGenerationStatus}
      reportGenerationTask={bulkTicketSaleReportGenerationTask}
      reportPrefix={BULK_TICKET_SALE_REPORT_PREFIX}
      reportPath={BULK_TICKET_SALE_REPORT_PATH}
      onCreateReport={params => dispatch(createBulkTicketSaleReport(params)).unwrap()}
      onFetchReport={(reportName, params) =>
        dispatch(fetchBulkTicketSaleReport({ report_name: reportName, ...params })).unwrap()
      }
      onResetWebsocket={() => dispatch(resetBulkTicketSaleReportWebsocket())}
    />
  )
}
